import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "./AddContent.module.css";
import "@/assets/css/style.css";

import { useAppSelector } from "@/store/hooks";

const ContentForm: React.FC = () => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;

    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const [image, setImage] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string>("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const { token } = useAppSelector((state) => state.auth);


    useEffect(() => {
        if (id) {
            fetch(`${baseUrl}/content/content/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log("data line no 24", data);
                    if (data.success && data.data) {
                        setTitle(data.data.title || "");
                        setDescription(data.data.desc || "");
                        if (data.data.image) setPreviewUrl(data.data.image);
                    }
                });
        }
    }, [id]);

    useEffect(() => {
        if (image) {
            const url = URL.createObjectURL(image);
            setPreviewUrl(url);
            return () => URL.revokeObjectURL(url);
        }
    }, [image]);

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.[0]) setImage(e.target.files[0]);
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formData = new FormData();
            if (image) formData.append("image", image);
            formData.append("title", title);
            formData.append("description", description);
            // /api/v1/content/content/id
            const url = `${baseUrl}/content/content/${id}`

            const method = "PUT"

            const res = await fetch(url, {
                method,
                body: formData,
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = await res.json();
            if (data.success) {
                alert(id ? "Content updated!" : "Content added!");
                navigate("/content");
            } else {
                alert(data.message || "Something went wrong!");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="side-app">
            <div className="main-container container-fluid">
                {/* PAGE HEADER */}
                <div className="page-header">
                    <h1 className="page-title">{id ? "Edit Home Content Feature" : "Add Home Content Feature"}</h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active">Content Features</li>
                    </ol>
                </div>

                {/* FORM */}
                <div className="row">
                    <div className="col-xl-12 col-md-12">
                        <form className="card" onSubmit={handleSubmit}>
                            <div className="card-body">
                                {/* Title */}
                                <div className="form-group">
                                    <label className="form-label">Title </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Description </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </div>
                                {/* Upload box */}
                                <div
                                    className="upload-box mb-4"
                                    onClick={() => document.getElementById("fileInput")?.click()}
                                    style={{
                                        border: "2px dashed #bbb",
                                        borderRadius: "12px",
                                        padding: "30px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        background: "#fafafa",
                                        transition: "0.3s",
                                    }}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        if (e.dataTransfer.files[0]) {
                                            setImage(e.dataTransfer.files[0]);
                                        }
                                    }}
                                >
                                    {previewUrl ? (
                                        <div>
                                            <img
                                                src={previewUrl}
                                                alt="Preview"
                                                className="img-fluid rounded shadow"
                                                style={{ maxHeight: "200px", objectFit: "cover" }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger mt-3"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setImage(null);
                                                    setPreviewUrl("");
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <p className="fw-bold mb-1">Drag & Drop your image here</p>
                                            <p className="text-muted mb-0">or click to browse</p>
                                            <small className="d-block mt-2">
                                                Recommended: 150 Px × 150 Px
                                            </small>
                                        </>
                                    )}
                                    <input
                                        id="fileInput"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}
                                        required={!id}
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? (id ? "Updating…" : "Uploading…") : id ? "Update" : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentForm;
